// Shared style helper functions for sentiment and impact badges

import { SENTIMENT_COLORS, IMPACT_COLORS } from '../constants/colors';

/**
 * Get style for sentiment label (positive/negative/neutral)
 * @param {string} label - Sentiment label
 * @returns {object} Style object with background and color
 */
export const sentimentStyle = (label) => {
    if (label === 'positive') return SENTIMENT_COLORS.positive;
    if (label === 'negative') return SENTIMENT_COLORS.negative;
    return SENTIMENT_COLORS.neutral;
};

/**
 * Get style for impact level (high/medium/low)
 * @param {string} level - Impact level
 * @returns {object} Style object with background and color
 */
export const impactStyle = (level) => {
    if (level === 'high') return IMPACT_COLORS.high;
    if (level === 'medium') return IMPACT_COLORS.medium;
    return IMPACT_COLORS.low;
};

/**
 * Get style for market sentiment (bullish/bearish/neutral)
 * @param {string} sentiment - Market sentiment
 * @returns {object} Style object with background and color
 */
export const marketSentimentStyle = (sentiment) => {
    if (sentiment === 'bullish') return SENTIMENT_COLORS.bullish;
    if (sentiment === 'bearish') return SENTIMENT_COLORS.bearish;
    return SENTIMENT_COLORS.neutral;
};

/**
 * Get color based on price change
 * @param {number} changePercent - Percentage change
 * @returns {string} Color string (green for up, red for down)
 */
export const getChangeColor = (changePercent) => {
    if (changePercent == null) return '#86868B';
    return changePercent >= 0 ? '#34C759' : '#FF3B30';
};

/**
 * Get rank medal color for leaderboards
 * @param {number} rank - Rank position (1-indexed)
 * @returns {string} Color for the rank badge
 */
export const getRankColor = (rank) => {
    if (rank === 1) return '#FFD700'; // Gold
    if (rank === 2) return '#C0C0C0'; // Silver
    if (rank === 3) return '#CD7F32'; // Bronze
    return '#86868B';
};

export default {
    sentimentStyle,
    impactStyle,
    marketSentimentStyle,
    getChangeColor,
    getRankColor,
};
